import { encryptedRequest, IResponse } from "../auth/api";
import { API_PATHS } from "../constants/api.constants";
import { REFRESH_KEY } from "../constants/sso.constants";

export const verifyToken = async (
  mobileNo: string,
  flag: true | typeof REFRESH_KEY = true,
  token?: string,
  p_token?: string
) => {
  const response = await encryptedRequest<string>({
    method: "POST",
    url: API_PATHS.verifyToken,
    data: {
      mobileNo,
      flag,
      token,
      p_token,
    },
  });

  if (response.statusCode !== 90) {
    throw new Error(response.message);
  }

  return response;
};

export const setPerpetualToken = async (mobileNo: string) => {
  const response = await encryptedRequest<string>({
    method: "POST",
    url: API_PATHS.generatePerpetualToken,
    data: {
      mobileNo,
    },
  });

  if (response.statusCode !== 90) {
    throw new Error(response.message);
  }

  return response;
};

export const logout = async (mobileNo: string, p_token?: string): Promise<IResponse<string>> => {
  const response = await encryptedRequest<string>({
    method: "POST",
    url: API_PATHS.logout,
    data: {
      mobileNo,
      p_token,
    },
  });

  if (response.statusCode !== 90) {
    throw new Error(response.message);
  }

  return response;
};
